import React from 'react';
import * as styles from '../styles/SweetAlertStyles';
var SuccessIcon = function () { return (React.createElement("div", { style: Object.assign({}, styles.icon, styles.iconSuccess) },
    React.createElement("div", { style: Object.assign({}, styles.iconSuccessBeforeAfter, styles.iconSuccessBefore) }),
    React.createElement("span", { style: Object.assign({}, styles.iconSuccessLine, styles.iconSuccessLineTip) }),
    React.createElement("span", { style: Object.assign({}, styles.iconSuccessLine, styles.iconSuccessLineLong) }),
    React.createElement("div", { style: styles.iconSuccessPlaceholder }),
    React.createElement("div", { style: styles.iconSuccessFix }),
    React.createElement("div", { style: Object.assign({}, styles.iconSuccessBeforeAfter, styles.iconSuccessAfter) }))); };
export default SuccessIcon;
//# sourceMappingURL=SuccessIcon.js.map